/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatDelete } from "../funcs/chatDelete.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteChatRequest,
  DeleteChatSecurity,
} from "../models/operations/deletechat.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type ChatDeleteMutationVariables = {
  request: DeleteChatRequest;
  security?: DeleteChatSecurity | undefined;
  options?: RequestOptions;
};

export type ChatDeleteMutationData = void;

export type ChatDeleteMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteChat chat
 *
 * @remarks
 * Soft-delete a chat by its ID
 */
export function useChatDeleteMutation(
  options?: MutationHookOptions<
    ChatDeleteMutationData,
    ChatDeleteMutationError,
    ChatDeleteMutationVariables
  >,
): UseMutationResult<
  ChatDeleteMutationData,
  ChatDeleteMutationError,
  ChatDeleteMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildChatDeleteMutation(client, options),
    ...options,
  });
}

export function mutationKeyChatDelete(): MutationKey {
  return ["@gram/client", "chat", "delete"];
}

export function buildChatDeleteMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: ChatDeleteMutationVariables,
  ) => Promise<ChatDeleteMutationData>;
} {
  return {
    mutationKey: mutationKeyChatDelete(),
    mutationFn: function chatDeleteMutationFn({
      request,
      security,
      options,
    }): Promise<ChatDeleteMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(chatDelete(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
